import Hit from "./hit.ce";
import Animation from "./animation.ce";
import Fx from "./fx.ce";

export const PrebuiltComponentAnimations = {
    Hit,
    Animation,
    Fx
}
